// const _import =
export default [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "auth" */ '@/pages/auth/login.vue'),
    name: 'auth.login',
    meta: {
      title: '登录',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/auth.js